import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, CreditCard, Globe, KeyRound, ShieldCheck, User, Users } from "lucide-react";
import { Logo } from "@/components/mdh/Nav";
import ProfileTab from "@/components/settings/ProfileTab";
import BillingTab from "@/components/settings/BillingTab";
import TeamTab from "@/components/settings/TeamTab";
import PortalTab from "@/components/settings/PortalTab";
import SecurityPanel from "@/components/settings/SecurityPanel";
import ApiTokensTab from "@/components/settings/ApiTokensTab";

const TABS = [
    { id: "profile", label: "Profile", icon: User },
    { id: "api", label: "API", icon: KeyRound },
    { id: "billing", label: "Billing", icon: CreditCard },
    { id: "team", label: "Team", icon: Users },
    { id: "portal", label: "Portal", icon: Globe },
    { id: "security", label: "Security", icon: ShieldCheck },
];

export default function Settings() {
    const [params, setParams] = useSearchParams();
    const tab = params.get("tab") || "profile";

    const go = (id) => setParams({ tab: id }, { replace: true });

    return (
        <div data-testid="settings-page" className="relative min-h-screen">
            <div
                className="bg-grid-slate pointer-events-none absolute inset-0 opacity-40"
                aria-hidden="true"
            />
            <header className="relative mx-auto flex h-16 max-w-5xl items-center justify-between px-5 lg:px-8">
                <Logo />
                <Link
                    to="/dashboard"
                    data-testid="settings-back-link"
                    className="flex items-center gap-1.5 font-mono text-[11px] text-slate-500 hover:text-cyan-300"
                >
                    <ArrowLeft className="h-3 w-3" /> Dashboard
                </Link>
            </header>

            <div className="relative mx-auto max-w-5xl px-5 pb-24 pt-10 lg:px-8">
                <h1 className="font-hero text-3xl font-bold tracking-tight text-slate-100 sm:text-4xl">
                    Settings
                </h1>
                <p className="mt-2 text-sm text-slate-400">
                    Your account, plan, team, and customer-facing portal.
                </p>

                <div className="mt-8 flex flex-wrap gap-1.5 border-b border-slate-800/80 pb-px">
                    {TABS.map((t) => {
                        const Icon = t.icon;
                        const active = tab === t.id;
                        return (
                            <button
                                key={t.id}
                                data-testid={`settings-tab-${t.id}`}
                                onClick={() => go(t.id)}
                                className={`flex items-center gap-2 rounded-t-md border-b-2 px-4 py-2.5 font-mono text-[11px] transition-colors ${
                                    active
                                        ? "border-cyan-400 bg-cyan-950/30 text-cyan-300"
                                        : "border-transparent text-slate-500 hover:bg-slate-900 hover:text-slate-300"
                                }`}
                            >
                                <Icon className="h-3.5 w-3.5" />
                                {t.label}
                            </button>
                        );
                    })}
                </div>

                <div className="mt-6">
                    {tab === "profile" && <ProfileTab />}
                    {tab === "api" && <ApiTokensTab />}
                    {tab === "billing" && <BillingTab />}
                    {tab === "team" && <TeamTab onViewPlans={() => go("billing")} />}
                    {tab === "portal" && <PortalTab />}
                    {tab === "security" && <SecurityPanel />}
                </div>
            </div>
        </div>
    );
}
